import { render, staticRenderFns } from "./ShopsView.vue?vue&type=template&id=5d2d1481&scoped=true&"
import script from "./ShopsView.vue?vue&type=script&lang=js&"
export * from "./ShopsView.vue?vue&type=script&lang=js&"
import style0 from "./ShopsView.vue?vue&type=style&index=0&id=5d2d1481&lang=scss&scoped=true&"
import style1 from "./ShopsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d1481",
  null
  
)

export default component.exports